import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

export function useBackgroundVideoContainerAnalytics() {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const firePlayPauseClicked = useCallback(
        (label: "play" | "pause") => {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "playPause",
                source: "backgroundVideoContainer",
                attributes: { label }
            }).fire();
        },
        [createAnalyticsEvent]
    );

    return { firePlayPauseClicked };
}
